export const MENU_ITEM_PADDING = "8px 16px";
